<div class="card cardsmall">
    <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
            <h2>{{model.name}}</h2>
            <form [formGroup]="form">
                <p-tabView>
                    <ng-container *ngFor="let tab of tabsFields">
                        <p-tabPanel header="{{tab.title}}">
                            <div class="formgrid">       
                                <formly-form [model]="model" 
                                [fields]="tab.fields" 
                                [options]="options" 
                                [form]="form"></formly-form>                     
                            </div>
                        </p-tabPanel>
                    </ng-container>
                    <p-tabPanel header="Steps progetto" *ngIf="action!='new'">
                        <app-subpanel
                            [editable]="false"
                            module="projects"
                            subPanel="subPanelSteps"
                            [reorderable]="true"
                            listUrl="app/projectssteps_listall"
                            [listParams]="stepsListParams"
                            nuovoLabel="Nuovo step"
                            (messageEvent)="dataListFromSteps($event)">
                        </app-subpanel>
                    </p-tabPanel>
                    <p-tabPanel header="Billing" *ngIf="action!='new'">
                        <app-subpanel
                            module="projects"
                            subPanel="subPanelBilling"
                            listUrl="app/billings_listall"
                            [listParams]="billingsListParams"
                            nuovoLabel="Nuova fatturazione"
                            (messageEvent)="dataListFromBillings($event)">
                        </app-subpanel>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="Annulla"></button>
                <button  *ngIf="action!='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="!form.valid"
                label="Salva" icon="pi pi-fw pi-check"></button>
                <button  *ngIf="action=='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="delete()"
                label="Cancella" icon="pi pi-fw pi-trash"></button>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>

